// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"8cd00bf1","810":"3575dbaf","1901":"e7d17f77","3065":"99a6a7b8","4677":"3575dbaf","5380":"3575dbaf","8529":"61c631af"}[chunkId] + ".chunk.css";
};